import { ApiClient } from '../lib/api';
import { Warranty, WarrantySchema } from '../models/warranty';

export class WarrantiesService {
    private api: ApiClient;

    constructor(baseURL: string, stage: string) {
        this.api = new ApiClient(`${baseURL}/${stage}/warranties-service-${stage}`, stage);
    }

    private setDefaults(data: unknown): Warranty {
        return WarrantySchema.parse(data);
    }

    async getAllWarranties(): Promise<Warranty[]> {
        const warranties = await this.api.request(
            { method: 'GET', url: '/warranties' },
            WarrantySchema.array()
        );
        return warranties.map(warranty => this.setDefaults(warranty));
    }

    async getWarrantyById(id: number): Promise<Warranty> {
        const warranty = await this.api.request(
            { method: 'GET', url: `/warranties/${id}` },
            WarrantySchema
        );
        return this.setDefaults(warranty);
    }
} 